// テスト用
const wait = (sec) => {
  return new Promise((resolve, reject) => {
    setTimeout(resolve, sec * 1000);
  });
};

const loadValues = async () => {
  await wait(3);
  // const res = await fetch("https://us-central1-tobiratory.cloudfunctions.net/background");
  // const json = await res.json();
  // console.log(json);
  // return [json.data.v1, json.data.v2, json.data.v3];
  return [111000, 367872, 306]; // mock
};

const executeCounter = (el, v) => {
  const id = setInterval(() => {
    const newV = parseInt(el.text().replaceAll(",", "")) + Math.trunc(v / 100);
    el.text(newV.toLocaleString());
    if (newV >= v) {
      // 指定の値に達したら終了
      el.text(v.toLocaleString());
      clearInterval(id);
    }
  }, 10);
  return;
};

const animateBgNums = async () => {
  const elV1 = $("#bg-v1");
  const elV2 = $("#bg-v2");
  const elV3 = $("#bg-v3");
  elV1.text(0);
  elV2.text(0);
  elV3.text(0);
  const [v1, v2, v3] = await loadValues();

  executeCounter(elV1, v1);
  executeCounter(elV2, v2);
  executeCounter(elV3, v3);
};

animateBgNums();
